import React, { useEffect, useState } from "react";
import { User } from "lucide-react";
import { getUserAvatarBackground } from "../../utils/reportsHelper";

const UserGradientAvatar = ({
  src,
  alt,
  userId,
  backgroundImageOverride,
  className = "h-8 w-8",
}) => {
  const [hasError, setHasError] = useState(false);
  const showImage = Boolean(src) && !hasError;
  const backgroundImage =
    backgroundImageOverride || getUserAvatarBackground(userId || alt);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  return (
    <div
      className={`relative flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-gray-300 ${className}`}
      style={{ backgroundImage }}
    >
      {!showImage && <User className="h-4 w-4 text-black" strokeWidth={1.75} />}
      {showImage ? (
        <img
          src={src}
          alt={alt}
          className="h-full w-full object-cover"
          onError={() => setHasError(true)}
        />
      ) : null}
    </div>
  );
};

export default UserGradientAvatar;
